import React from 'react';

import ImageBlurFallback from '../../Components/ImageBlurFallback';
import { CLIENT_URL_IMAGE } from '../../config.local';

const text = 'Programming language and tools you will learn';

const ToolsToLearn = ({ tools }) => {
  return tools && tools.length ? (
    <div className="liveclasses-toolstolearn-container">
      <span className="toolstolearn-heading">{text}</span>
      <div className="toolstolearn-images-container">
        {tools.map(image => (
          <ImageBlurFallback
            className="toolstolearn-imagebox"
            src={`${CLIENT_URL_IMAGE}${image}`}
            alt={text}
            key={image}
          />
        ))}
      </div>
    </div>
  ) : null;
};
export default ToolsToLearn;



// WEBPACK FOOTER //
// ./src/Pages/LiveClass/ToolsToLearn.js